import React from 'react';
import { useSwipeable } from 'react-swipeable';
import line from '../../assets/line.svg';

interface DragHandleProps {
  onClose: () => void;
  disabled?: boolean;
  className?: string;
}

const DragHandle: React.FC<DragHandleProps> = ({
  onClose,
  disabled = false,
  className = '',
}) => {
  const swipeHandlers = useSwipeable({
    onSwipedDown: (eventData) => {
      if (eventData.deltaY > 50 && !disabled) {
        onClose(); // Usa o mesmo evento passado pelo Modal
      }
    },
    delta: 50,
    trackMouse: false,
    trackTouch: true,
    preventScrollOnSwipe: true,
  });

  return (
    <div
      className={`modal-drag-handle ${className}`}
      {...swipeHandlers}
      style={{
        padding: '15px 0 10px 0',
        cursor: disabled ? 'default' : 'grab',
        userSelect: 'none',
        touchAction: 'none',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <img
        alt='drag-handle'
        src={line}
        style={{
          transition: 'opacity 0.2s ease',
        }}
      />
    </div>
  );
};

export default DragHandle;
